import { c as _c } from "react/compiler-runtime";
import { Icon, TextLink } from '@petsmart-ui/sparky';
import { trackNavigationHeaderClick, useServicesLinkClick } from '../../../../../shared';
import type { NavigationPanel } from '../../../../../types';
import { LinksColumns } from './links-columns';
import { VisualItemsGrid } from './visual-items-grid';
import './panel-body.scss';
type PanelBodyProps = {
  panel: NavigationPanel;
  selectionPath: string[];
  showOverviewLink?: boolean;
};
export function PanelBody(t0) {
  const $ = _c(15);
  const {
    panel,
    selectionPath,
    showOverviewLink: t1
  } = t0;
  const showOverviewLink = t1 === undefined ? true : t1;
  const overviewLink = panel.overviewLink;
  const handleServicesLinkClick = useServicesLinkClick();
  let t2;
  if ($[0] !== panel.content.columns || $[1] !== panel.content.desktopColumnCount || $[2] !== panel.content.items || $[3] !== panel.content.kind || $[4] !== panel.content.layout || $[5] !== selectionPath) {
    t2 = panel.content.kind === "columns" ? <LinksColumns columns={panel.content.columns} desktopColumnCount={panel.content.desktopColumnCount} selectionPath={selectionPath} /> : <VisualItemsGrid items={panel.content.items} layout={panel.content.layout} selectionPath={selectionPath} />;
    $[0] = panel.content.columns;
    $[1] = panel.content.desktopColumnCount;
    $[2] = panel.content.items;
    $[3] = panel.content.kind;
    $[4] = panel.content.layout;
    $[5] = selectionPath;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== handleServicesLinkClick || $[8] !== overviewLink || $[9] !== selectionPath || $[10] !== showOverviewLink) {
    t3 = showOverviewLink && overviewLink && <TextLink href={overviewLink.href} className="panel-body__overview-link sparky-c-text-passage--lg" rel={overviewLink.openInNewTab ? "noopener noreferrer" : undefined} target={overviewLink.openInNewTab ? "_blank" : undefined} onClick={event => {
      trackNavigationHeaderClick({
        selection: [...selectionPath, overviewLink.label],
        linkUrl: overviewLink.href,
        navSection: "main nav"
      });
      handleServicesLinkClick({
        event,
        link: overviewLink.href,
        shouldOpenInNewTab: overviewLink.openInNewTab
      });
    }}>{overviewLink.label}<Icon name="chevron-right" size="lg" className="panel-body__overview-link-icon" aria-hidden="true" /></TextLink>;
    $[7] = handleServicesLinkClick;
    $[8] = overviewLink;
    $[9] = selectionPath;
    $[10] = showOverviewLink;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div className="panel-body">{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}